import { ClerkLoaded, ClerkLoading, RedirectToSignIn, Show } from '@clerk/react-router';
import type { ReactNode } from 'react';
import { AppBootScreen } from './app-boot-screen.tsx';

type AuthGuardProps = {
    children: ReactNode;
};

export function AuthGuard({ children }: AuthGuardProps) {
    return (
        <>
            <ClerkLoading>
                <AppBootScreen />
            </ClerkLoading>
            <ClerkLoaded>
                <Show when="signed-in">{children}</Show>
                <Show when="signed-out">
                    <RedirectToSignIn />
                </Show>
            </ClerkLoaded>
        </>
    );
}
